import React, { Component } from 'react';
import { connect } from 'react-redux';
import LOOKUP from 'constants/lookup';
import { ProductCategoryBulkPriceType, PriceByCategoryMode } from 'constants/enums';
import { selectProductCategoryModel } from 'selectors/entitySelector';
import { categoryEditCrumb, categoryAddCrumb } from 'utils/breadcrumbInfo';
import { mapClassOfCannabis } from 'utils/mappers';
import util from 'library/util';
import { getProductCategory, saveCategory, getTaxesRate, getClassesOfCannabis, getProductTypes, setPriceByCategory, clearProductTypeList } from 'actions/EntityActions';
import { initializeProductCategoryForm, clearFormInput, formInput, formError, clearFormErrors } from 'actions/FormActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { getProductCategoryBulkUpdatePriceHistory } from 'actions/EntityActions';
import { saveProductCategoryTaxProvince } from 'actions/EntityActions';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import ToggleInput from 'screens/components/basic/ToggleInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import Grid from 'screens/components/basic/Grid';
import DialogHeader from 'screens/components/basic/DialogHeader';
import CheckInput from 'screens/components/basic/CheckInput';
import './style/ProductCategorySave.css';
import DialogInput from 'screens/components/advanced/DialogInput';
import ProductCategoryBulkUpdatePriceHistoryList from './ProductCategoryBulkUpdatePriceHistoryList';
import WithRouter from 'custom/withRouter';
import PageHeader from 'screens/components/basic/PageHeader';

const CANADIAN_PROVINCES = [
    { code: 1, abbr: "AB", name: "Alberta" },
    { code: 2, abbr: "BC", name: "British Columbia" },
    { code: 3, abbr: "ON", name: "Ontario" },
    { code: 4, abbr: "NL", name: "Newfoundland and Labrador" },
    { code: 5, abbr: "MB", name: "Manitoba" },
    { code: 6, abbr: "SK", name: "Saskatchewan" },
    { code: 7, abbr: "YT", name: "Yukon" },
    { code: 8, abbr: "NB", name: "New Brunswick" },
    { code: 9, abbr: "NS", name: "Nova Scotia" },
    { code: 10, abbr: "PE", name: "Prince Edward Island" },
    { code: 11, abbr: "QC", name: "Quebec" },
    { code: 12, abbr: "NT", name: "Northwest Territories" },
    { code: 13, abbr: "NU", name: "Nunavut" }
];

class ProductCategorySave extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dialogConfirm: false,
            isOpen: false,
            confirmCategoryUpdateMemberPriceHistoryDialog: false,
            confirmOneCategoryUpdateMemberPriceHistoryDialog: false,
            selectedCategoryId: 0,
            showTaxDialog: false,
            selectedTax: null,
        };
    }

    componentWillMount() {
        this.props.getTaxesRate(this.props.branchId);
        this.props.getClassesOfCannabis();

        const productCategoryId = this.props.params ? this.props.params.id : 0;
        if (productCategoryId) {
            this.setState({ status: "EDIT" }, () => { this.props.getProductCategory(productCategoryId); });
        }
        else {
            this.setState({ status: "ADD" }, () => { this.props.init(); });
        }
    }

    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != null && newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)
            || (newProps.saveError != null && newProps.saveError != undefined && newProps.saveError !== this.props.saveError)) {
            if (newProps.saveSuccess === true)
                this.saveSuccess();
            else
                this.saveFailure();
        }

        if (newProps.saveProductCategoryTaxProvinceSuccessTime && newProps.saveProductCategoryTaxProvinceSuccessTime !== this.props.saveProductCategoryTaxProvinceSuccessTime) {
            const productCategoryId = this.props.params ? this.props.params.id : 0;
            if (productCategoryId) {
                this.setState({ status: "EDIT" }, () => { this.props.getProductCategory(productCategoryId); });
            }

            // Optionally close dialog or show a message
            this.setState({ showTaxDialog: false, selectedTax: null });
        }

        if (newProps.saveProductCategoryTaxProvinceErrorTime && newProps.saveProductCategoryTaxProvinceErrorTime !== this.props.saveProductCategoryTaxProvinceErrorTime) {
            this.props.showError(newProps.saveProductCategoryTaxProvinceError);
        }
    }

    componentWillUnmount() {
        this.props.clearProductTypeList();
        this.props.clearFormInput(this.props.name + "Name");
        this.props.clearFormInput(this.props.name + "ClassOfCannabis");
        this.props.clearFormInput(this.props.name + "UnitOfMeasurement");
        this.props.clearFormInput(this.props.name + "BulkPriceType");
        this.props.clearFormInput(this.props.name + "BulkPriceValue");
        this.props.formInput(false, this.props.name + "UseAllBranchesPO");
        this.props.clearFormErrors();
        // Clear all TaxProvinceMode- and TaxProvinceSelections- fields from form state
        Object.keys(this.props.form).forEach(key => {
            if (
                key.startsWith(this.props.name + "TaxProvinceMode-") ||
                key.startsWith(this.props.name + "TaxProvinceSelections-")
            ) {
                this.props.clearFormInput(key);
            }
        });
    }

    saveSuccess = () => {
        this.props.onCancel();
        this.props.showSnackbar(this.state.status === "EDIT" ? LOOKUP.productCategory.editedMessage : LOOKUP.productCategory.createdMessage);
        if (this.props.isDialog) {
            this.props.getProductTypes();
        }
    }

    saveFailure = () => {
        this.props.showError(LOOKUP.productCategory.saveErrorMessage);
    }

    addCategory = () => {
        const p = this.props;
        let category = p.productCategoryModel;

        const validators = [
            [p.name + 'Name', c => (c.Name !== null && c.Name !== ""), 'Name']
        ];
        category.Id = this.props.params && this.props.params.id ? parseInt(this.props.params.id) : 0;
        if (util.validate(validators, category, this.props.formError)) {
            this.props.saveCategory(category);
        }
    }

    changePriceType = () => {
        this.setState({ bulkvalue: 0 });
    }

    updateProductPrice = (mode) => {
        const productCategoryId = this.props.params ? this.props.params.id : 0;
        const autoRoundingPrices = this.props.form[this.props.name + "AutoRoundingPrices"];

        let model = {
            BranchId: this.props.branchId,
            CategoryId: productCategoryId,
            BulkPriceValue: this.props.BulkPriceValue,
            BulkPriceValueType: this.props.BulkPriceType,
            PriceByCategoryMode: mode,
            useAllBranchesPO: this.props.useAllBranchesPO,
            AutoRoundingPrices: autoRoundingPrices
        }
        this.props.setPriceByCategory(model);
        this.closeConfirmUpdatePrice();
    }

    openConfirmUpdatePrice = () => {
        this.setState({ dialogConfirm: true });
    }

    openCategoryBulkUpdateMemberPriceHistoryDialog = () => {
        this.setState({ confirmCategoryUpdateMemberPriceHistoryDialog: true, confirmOneCategoryUpdateMemberPriceHistoryDialog: false, selectedCategoryId: 0 });
    }

    openOneCategoryBulkUpdateMemberPriceHistoryDialog = (categoryId) => {
        const productCategoryId = this.props.params ? this.props.params.id : 0;
        this.setState({ confirmCategoryUpdateMemberPriceHistoryDialog: false, confirmOneCategoryUpdateMemberPriceHistoryDialog: true, selectedCategoryId: productCategoryId });
        this.props.getProductCategoryBulkUpdatePriceHistory(this.props.branchId, productCategoryId);
    }

    categoryUpdateMemberPriceHistoryCancel = () => {
        this.setState({ confirmCategoryUpdateMemberPriceHistoryDialog: false, confirmOneCategoryUpdateMemberPriceHistoryDialog: false, selectedCategoryId: 0 });
    }

    closeConfirmUpdatePrice = () => {
        this.setState({ dialogConfirm: false });
    }

    // --- Province Tax Toggle Handler ---
    handleProvinceTaxToggle = (taxId, checked) => {
        // Save to form state so it persists and can be saved to DB
        this.props.formInput(checked, `${this.props.name}TaxProvinceMode-${taxId}`);
        // If unchecked, also clear province selections
        if (!checked) {
            this.props.formInput([], `${this.props.name}TaxProvinceSelections-${taxId}`);
        }
    };

    // --- Province Checkbox Handler ---
    handleProvinceCheckboxChange = (taxId, provinceCode, checked) => {
        const key = `${this.props.name}TaxProvinceSelections-${taxId}`;
        const prev = this.props.form[key] || [];
        let updated;
        if (checked) {
            updated = [...prev, provinceCode];
        } else {
            updated = prev.filter(code => code !== provinceCode);
        }
        this.props.formInput(updated, key);
    };

    handleSaveTaxProvince = () => {
        const { selectedTax } = this.state;
        if (!selectedTax) return;
        const taxId = selectedTax.id;
        const taxProvinceMode = this.props.form[`${this.props.name}TaxProvinceMode-${taxId}`] || false;
        const taxProvinceSelections = this.props.form[`${this.props.name}TaxProvinceSelections-${taxId}`] || [];
        // Call the action to save province tax settings
        this.props.saveProductCategoryTaxProvince({
            categoryId: this.props.productCategoryModel.Id,
            taxRateId: taxId,
            isProvinceTax: taxProvinceMode,
            provinceCodes: taxProvinceSelections
        });
    };

    handleTaxProvinceDialogClose = () => {
        this.setState({ showTaxDialog: false, selectedTax: null });
        const productCategoryId = this.props.params ? this.props.params.id : 0;
        if (productCategoryId) {
            this.setState({ status: "EDIT" }, () => { this.props.getProductCategory(productCategoryId); });
        }
    }

    render() {
        const productCategoryId = this.props.params ? this.props.params.id : 0;
        const p = this.props;
        const title = this.state.status === 'EDIT' ? LOOKUP.productCategory.titles.edit : LOOKUP.productCategory.titles.add;
        const breadCrumbPage = this.state.status === 'EDIT' ? categoryEditCrumb : categoryAddCrumb;
        const priceType = [
            { text: "Price Margin %", value: "1" },
            { text: "Price Per Unit $", value: "2" },
            { text: "Price Per Unit %", value: "3" }
        ];
        // Use values from props.form for taxProvinceMode and taxProvinceSelections
        const getTaxProvinceMode = (taxId) => {
            return this.props.form[`${this.props.name}TaxProvinceMode-${taxId}`] || false;
        };
        const getTaxProvinceSelections = (taxId) => {
            return this.props.form[`${this.props.name}TaxProvinceSelections-${taxId}`] || [];
        };

        return (
            <Grid headerContent={breadCrumbPage}>
                {
                    p.isDialog ? "" :
                        <PageHeader title={title} />
                }
                <CardSimple>
                    <div className="row">
                        <div className="col-xs-12">
                            <h3>General</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <TextInput
                                name={`${p.name}Name`}
                                fullWidth={true}
                                maxLength={40}
                                label={LOOKUP.productCategory.name.label}
                                floatingLabelText={LOOKUP.productCategory.name.label}
                                hintText={LOOKUP.productCategory.name.hintText}
                                required />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-4">
                            <ToggleInput
                                name={`${p.name}IsCannabis`}
                                label={p.isVape ? LOOKUP.productCategory.isVape.label : LOOKUP.productCategory.isCannabis.label}
                                className="toggle-yes-no btnToggleLabel"
                                text="No"
                                text2="Yes"
                            />
                        </div>
                        <div className="col-xs-12 col-sm-4">
                            <ToggleInput name={`${p.name}Status`} label={LOOKUP.productCategory.status.label} className="toggle-active-inactive btnToggleLabel" text="Inactive" text2="Active" />
                        </div>
                        <div className="col-xs-12 col-sm-4">
                            <ToggleInput name={`${p.name}IsRefundable`} label={LOOKUP.productCategory.isRefundable.label} className="toggle-yes-no btnToggleLabel" text="No" text2="Yes" />
                        </div>
                    </div>
                    {p.isVape ? null : (
                        <div>
                            <div className="row">
                                <div className="col-xs-12">
                                    {p.isCannabis && (
                                        <SelectInput
                                            name={`${p.name}ClassOfCannabis`}
                                            fullWidth={true}
                                            floatingLabelText={LOOKUP.productCategory.classOfCannabis.label}
                                            label={LOOKUP.productCategory.classOfCannabis.label}
                                            options={mapClassOfCannabis(p.classesOfCannabis)}
                                            hintText={LOOKUP.productCategory.classOfCannabis.hintText}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    {p.isCannabis && p.province && (p.province.toLowerCase() === "bc" || p.province.toLowerCase() === "british columbia") && (
                                        <SelectInput
                                            name={`${p.name}BCCannabisClass`}
                                            fullWidth={true}
                                            floatingLabelText={LOOKUP.productCategory.bcCannabisClassLabel.label}
                                            label={LOOKUP.productCategory.bcCannabisClassLabel.label}
                                            options={LOOKUP.productCategory.bcCannabisClass}
                                            hintText={LOOKUP.productCategory.bcCannabisClassLabel.hintText}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    {p.isCannabis && p.province && (p.province.toLowerCase() === "mb" || p.province.toLowerCase() === "manitoba") && (
                                        <SelectInput
                                            name={`${p.name}BCCannabisClass`}
                                            fullWidth={true}
                                            floatingLabelText={LOOKUP.productCategory.mbCannabisClassLabel.label}
                                            label={LOOKUP.productCategory.mbCannabisClassLabel.label}
                                            options={LOOKUP.productCategory.bcCannabisClass}
                                            hintText={LOOKUP.productCategory.mbCannabisClassLabel.hintText}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="row">
                        <div className="col-xs-12">
                            <SelectInput name={`${p.name}UnitOfMeasurement`}
                                floatingLabelText={LOOKUP.productCategory.unitOfMeasurementLabel.label}
                                label={LOOKUP.productCategory.unitOfMeasurementLabel.label}
                                options={LOOKUP.productCategory.unitOfMeasurement}
                                hintText={LOOKUP.productCategory.unitOfMeasurementLabel.hintText}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <p>Choose which tax rate is linked to this Category:</p>
                        </div>
                    </div>
                    <div className="row">
                        {
                            p.taxRates.map((item, index) => {
                                if (item.status === "Active") {
                                    // Check if this tax is selected in the form
                                    const isChecked = p.form && p.form[`${p.name}TaxRate-${item.id}`];
                                    // Province tax info
                                    const isProvinceTax = p.form && p.form[`${p.name}TaxProvinceMode-${item.id}`];
                                    const provinceCodes = p.form && p.form[`${p.name}TaxProvinceSelections-${item.id}`] || [];
                                    const appliedProvinces = CANADIAN_PROVINCES.filter(prov => provinceCodes.includes(prov.code));
                                    return (
                                        <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3" key={index} style={{ display: 'flex', alignItems: 'center' }}>
                                            <CheckInput
                                                name={`${p.name}TaxRate-${item.id}`}
                                                text={
                                                    <>
                                                        {item.name + " (" + parseInt(item.rate * 100) + "%)"}
                                                        {isProvinceTax && appliedProvinces.length > 0 && (
                                                            <div style={{ fontSize: 11, color: "#007bff", marginTop: 2 }}>
                                                                <span>Applied to: </span>
                                                                {appliedProvinces.map(prov => prov.abbr).join(', ')}
                                                            </div>
                                                        )}
                                                    </>
                                                }
                                                value={item.id}
                                                className="checkBoxLabels"
                                            />
                                            {isChecked ?
                                                <Button
                                                    primary={true}
                                                    className="ml-2"
                                                    label="Manage"
                                                    onTouchTap={() => this.setState({ showTaxDialog: true, selectedTax: item })}
                                                    style={{ minWidth: 30, minHeight: 30, marginLeft: 8 }}
                                                />
                                                : null
                                            }
                                        </div>
                                    )
                                }
                            })
                        }
                    </div>
                    {/* Tax Details Dialog */}
                    <DialogInput
                        title={<DialogHeader text="Manage Tax" />}
                        modal={true}
                        open={!!this.state.showTaxDialog}
                        handleClose={() => this.handleTaxProvinceDialogClose()}
                        actions={[
                            <Button
                                key="closeTaxDialog"
                                name="buttonCloseTaxDialog"
                                label="Close"
                                onTouchTap={() => this.handleTaxProvinceDialogClose()}
                            />,
                            <Button
                                key="saveTaxDialog"
                                name="buttonSaveTaxDialog"
                                label="Save"
                                primary={true}
                                onTouchTap={this.handleSaveTaxProvince}
                            />
                        ]}
                    >
                        {this.state.selectedTax &&
                            <div>
                                <h4>{this.state.selectedTax.name}</h4>
                                <p>Rate: {parseInt(this.state.selectedTax.rate * 100)}%</p>
                                <p>Status: {this.state.selectedTax.status}</p>
                                {/* Province Tax Toggle */}
                                <div style={{ marginTop: 16 }}>
                                    <label style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                        <input
                                            type="checkbox"
                                            checked={getTaxProvinceMode(this.state.selectedTax.id)}
                                            onChange={e =>
                                                this.handleProvinceTaxToggle(
                                                    this.state.selectedTax.id,
                                                    e.target.checked
                                                )
                                            }
                                            style={{ marginRight: 8 }}
                                        />
                                        Province Tax
                                    </label>
                                    {/* Province selection UI */}
                                    {getTaxProvinceMode(this.state.selectedTax.id) ? (
                                        <div>
                                            <b>Apply this tax to provinces:</b>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 8 }}>
                                                {CANADIAN_PROVINCES.map(prov => {
                                                    const appliedProvinces = getTaxProvinceSelections(this.state.selectedTax.id);
                                                    const checked = appliedProvinces.includes(prov.code);
                                                    return (
                                                        <label key={prov.code} style={{ width: '33%', marginBottom: 4 }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={checked}
                                                                onChange={e =>
                                                                    this.handleProvinceCheckboxChange(
                                                                        this.state.selectedTax.id,
                                                                        prov.code,
                                                                        e.target.checked
                                                                    )
                                                                }
                                                            />
                                                            {prov.name} ({prov.abbr})
                                                            {checked && <span style={{ color: 'green', marginLeft: 4 }}>(applied)</span>}
                                                        </label>
                                                    );
                                                })}
                                            </div>
                                            <div style={{ marginTop: 8 }}>
                                                <b>Currently applied to:</b>{" "}
                                                {(
                                                    getTaxProvinceSelections(this.state.selectedTax.id)
                                                ).map(code => {
                                                    const p = CANADIAN_PROVINCES.find(prov => prov.code === code);
                                                    return p ? p.name : code;
                                                }).filter(Boolean).join(', ') || <span style={{ color: '#888' }}>None</span>}
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{ marginTop: 8 }}>
                                            <b>This tax will be applied to all provinces.</b>
                                        </div>
                                    )}
                                </div>
                            </div>
                        }
                    </DialogInput>
                    {/* BULK UPDATE */}
                    <div className="row mt-1">
                        <div className="col-xs-12"><h3>Bulk Update Price By Category</h3></div>
                        <div className="col-xs-6">
                            <SelectInput
                                name={p.name + "BulkPriceType"}
                                fullWidth={true}
                                id="priceTypeDropdown"
                                label="Type"
                                floatingLabelText="Price Type"
                                hintText="Price Type"
                                options={priceType}
                                onChange={this.changePriceType}
                                required
                            />
                        </div>
                        <div className="col-xs-6">
                            {
                                p.BulkPriceType === ProductCategoryBulkPriceType.PricePerUnitPercentage ? (
                                    <DecimalInput
                                        fullWidth={true}
                                        type="number"
                                        name={`${p.name}BulkPriceValue`}
                                        floatingLabelText={`${LOOKUP.productCategory.pricePersent.label} (%)`}
                                        label={`${LOOKUP.productCategory.pricePersent.label} (%)`}
                                        hintText={`${LOOKUP.productCategory.pricePersent.hintText} (%)`}
                                        min={0}
                                        max={100} />
                                ) : p.BulkPriceType === ProductCategoryBulkPriceType.PricePerUnitAmount ? (
                                    <DecimalInput
                                        name={`${p.name}BulkPriceValue`}
                                        type="number"
                                        fullWidth={true}
                                        floatingLabelText={`${LOOKUP.productCategory.priceValue.label} ($)`}
                                        label={`${LOOKUP.productCategory.priceValue.label} ($)`}
                                        hintText={`${LOOKUP.productCategory.priceValue.hintText} ($)`}
                                        min={0}
                                        max={1000000}
                                    />
                                ) : p.BulkPriceType === ProductCategoryBulkPriceType.PriceMarginPercentage ? (
                                    <DecimalInput
                                        type="number"
                                        fullWidth={true}
                                        name={`${p.name}BulkPriceValue`}
                                        floatingLabelText={`${LOOKUP.productCategory.priceMargin.label} (%)`}
                                        label={`${LOOKUP.productCategory.priceMargin.label} (%)`}
                                        hintText={`${LOOKUP.productCategory.priceMargin.hintText} (%)`}
                                        max={100}
                                        min={0}
                                    />
                                ) : null
                            }
                        </div>

                        <ProductCategoryBulkUpdatePriceHistoryList
                            isOpen={this.state.confirmCategoryUpdateMemberPriceHistoryDialog || this.state.confirmOneCategoryUpdateMemberPriceHistoryDialog}
                            allCategory={this.state.confirmCategoryUpdateMemberPriceHistoryDialog}
                            oneCategory={this.state.confirmOneCategoryUpdateMemberPriceHistoryDialog}
                            onCancel={this.categoryUpdateMemberPriceHistoryCancel}
                            categoryId={productCategoryId}
                        />
                    </div>
                    <div className="row">
                        <div className="alert alert-warning" style={{ paddingBottom: 3 }}>
                            <div><b>Warning:</b></div>
                            <ul style={{ lineHeight: 2 }}>
                                <li>Price rounding will be applied by default and override the exact bulk updated prices. </li>
                                <li>If you wish to <b>fix the exact updated prices</b>, please use the toggle below to <b>deactivate</b> Price Rounding.</li>
                            </ul>
                        </div>
                        <div className="col-lg-6 col-xs-12">
                            <ToggleInput name={`${p.name}AutoRoundingPrices`} label="Price Rounding after Bulk Price Update" className="toggle-yes-no btnToggleLabel" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-xs-12">
                            <ToggleInput name={`${p.name}UseAllBranchesPO`} label="Use the latest PO between all branches" className="toggle-yes-no btnToggleLabel" />
                        </div>
                        <div className="col-xs-12 p-2">
                            <i className="danger">
                                By default the system uses latest PO from the current branch and the margin above to update the selling price. you can use the toggle above to change to using latest PO between all branches.
                            </i>
                        </div>
                    </div>
                    <div className="row mt-2 mb-2">
                        <div className="col-xs-12 d-flex align-items-center">
                            <Button
                                name="buttonNormal"
                                label={LOOKUP.productCategory.controls.normalMode}
                                primary={true}
                                className="btnNewBrandPOS"
                                onTouchTap={() => this.updateProductPrice(PriceByCategoryMode.Normal)} />
                            <Button
                                className="right-priceMargin-btn btnNewBrandPOS mx-1"
                                name="buttonAggressive"
                                label={LOOKUP.productCategory.controls.aggressiveMode}
                                primary={true}
                                onTouchTap={() => this.openConfirmUpdatePrice()} />
                            <Button
                                type="SaveButtonNoIcon"
                                name={`butShowHistory${productCategoryId}`}
                                label="View History"
                                className="right-priceMargin-btn mx-1"
                                onTouchTap={() => this.openOneCategoryBulkUpdateMemberPriceHistoryDialog(productCategoryId)}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 danger">
                            <b>Note: </b><i>We will use the PO cost for each product and the margin you set above to calculate the prices for the products under this category once you click the button above.</i>
                            <br />
                            <br />
                            <b>*Normal Mode: </b>If the price already exists for a product, we won't update the price.
                            <br />
                            <br />
                            <b>*Aggressive Mode: </b>The price will be overwritten even if it exists before.
                        </div>
                    </div>
                    {
                        this.props.autoUpdatePriceWhenReceivingPO &&
                        <div className="row">
                            <div className="col-xs-12"><h3>Price Margin For Auto Update Price When Receiving PO</h3></div>
                            <DecimalInput
                                type="number"
                                fullWidth={true}
                                name={`${p.name}priceMargin`}
                                floatingLabelText={`${LOOKUP.productCategory.priceMargin.label} (%)`}
                                label={`${LOOKUP.productCategory.priceMargin.label} (%)`}
                                hintText={`${LOOKUP.productCategory.priceMargin.hintText} (%)`}
                                max={100}
                                min={0}
                            />
                        </div>
                    }
                    <div className="row">
                        <div className="col-xs-12 mb-2">
                            <Button
                                name="saveButton"
                                className="pull-right btnNewBrandPOS"
                                label={LOOKUP.productCategory.controls.saveButton}
                                primary={true}
                                onTouchTap={() => this.addCategory()} />
                            <Button
                                type="CancelButton"
                                name="buttonCancel"
                                className="pull-right btn-space btnCancelOperation"
                                label={LOOKUP.productCategory.controls.cancelButton}
                                onTouchTap={p.onCancel} />
                        </div>
                    </div>
                </CardSimple>
                {/* Confirmation Dialog */}
                <DialogInput
                    title={<DialogHeader text="Update Price - Confirmation" />}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.closeConfirmUpdatePrice()} />,
                        <Button
                            key={2}
                            name="buttonRemoveItem"
                            label="Confirm"
                            primary={true}
                            className="btnNewBrandPOS"
                            onTouchTap={() => this.updateProductPrice(PriceByCategoryMode.Aggressive)} />]}
                    modal={true}
                    open={this.state.dialogConfirm}>
                    <div className="modal-font-family">
                        Are you sure that you want to update price in Aggressive Mode? (it will overwirte existing product prices with this category)
                    </div>
                </DialogInput>
            </Grid>
        );
    }
}

function mapStatetoProps(state, ownProps) {
    return {
        productCategoryModel: selectProductCategoryModel(state, ownProps.name),
        saveSuccess: state.form[ownProps.name + "SaveSuccess"],
        saveError: state.form[ownProps.name + "SaveError"],
        taxRates: state.entity.taxesrateList,
        isCannabis: state.form[ownProps.name + "IsCannabis"],
        classesOfCannabis: state.entity.classesOfCannabis,
        branchId: state.common.branchId,
        store: state.common.store,
        priceMargin: state.form[ownProps.name + "priceMargin"] ? state.form[ownProps.name + "priceMargin"] : 0,
        province: state.common.store.provinceState,
        useAllBranchesPO: state.form[ownProps.name + "UseAllBranchesPO"],
        isVape: state.common.applicationSettings.isVape,
        BulkPriceType: state.form[ownProps.name + "BulkPriceType"] ? parseInt(state.form[ownProps.name + "BulkPriceType"]) : 0,
        BulkPriceValue: state.form[ownProps.name + "BulkPriceValue"] ? parseFloat(state.form[ownProps.name + "BulkPriceValue"]) : 0,
        form: state.form,
        saveProductCategoryTaxProvinceSuccessTime: state.entity.saveProductCategoryTaxProvinceSuccessTime,
        saveProductCategoryTaxProvinceError: state.entity.saveProductCategoryTaxProvinceError,
        saveProductCategoryTaxProvinceErrorTime: state.entity.saveProductCategoryTaxProvinceErrorTime,
        autoUpdatePriceWhenReceivingPO: state.common.applicationSettings.autoUpdatePriceWhenReceivingPO,
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        init: () => dispatch(initializeProductCategoryForm(ownProps.name)),
        getProductCategory: (id) => dispatch(getProductCategory(id, ownProps.name)),
        getProductTypes: () => dispatch(getProductTypes()),
        formInput: (value, name) => dispatch(formInput(value, name)),
        formError: (name, error) => dispatch(formError(name, error)),
        saveCategory: (model) => dispatch(saveCategory(model, ownProps.name)),
        showError: (message) => dispatch(showError(message)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        getTaxesRate: (branchId) => dispatch(getTaxesRate(branchId)),
        getClassesOfCannabis: () => dispatch(getClassesOfCannabis()),
        setPriceByCategory: (model) => dispatch(setPriceByCategory(model)),
        clearProductTypeList: () => dispatch(clearProductTypeList()),
        getProductCategoryBulkUpdatePriceHistory: (branchId, categoryId) => dispatch(getProductCategoryBulkUpdatePriceHistory(branchId, categoryId)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        clearFormErrors: () => dispatch(clearFormErrors()),
        saveProductCategoryTaxProvince: (model) => dispatch(saveProductCategoryTaxProvince(model)),
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(ProductCategorySave));
